module.exports = __webpack_public_path__ + "static/blossom-logo-social-5aca78df9f998941e888f8f4db908ce6.png";